import axios from './rest-axios';

const getStocks = (page, size, year, type) => axios.get(`/manage/stocks`, {page, size, year, type});
const getStocksById = id => axios.get(`/manage/stocks/${id}`);
const addStock = stock => axios.post(`/manage/stocks`, stock);
const updateStock = stock => axios.put(`/manage/stocks/${stock.id}`, stock);
const deleteStock = id => axios.delete(`/manage/stocks/${id}`);
const copyStocksFromPreviousYear = (year) => axios.post(`/manage/stocks/copy`, {year});

export {
    getStocks,
    getStocksById,
    addStock,
    updateStock,
    deleteStock,
    copyStocksFromPreviousYear,
}
